import { Link } from 'react-router-dom';
import { allMovies } from '@/mocks/movies';

export default function FeaturedContent() {
  const featured = allMovies.filter((m) => parseFloat(String(m.rating)) >= 9.0);

  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">评分 9.0+ 的高分佳作</p>
          </div>
          <Link to="/category/sihu" className="text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap transition-colors">
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:bg-background-200"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={movie.imageUrl}
                  alt={movie.title}
                  title={`${movie.title} - ${movie.channel}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <span className="text-white text-xs font-medium whitespace-nowrap">{movie.channel}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {movie.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">{movie.description}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{movie.year}</span>
                  <span>·</span>
                  <span>{movie.duration}</span>
                  <span>·</span>
                  <span>{movie.views.toLocaleString()} 次播放</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}